import { NgModule } from '@angular/core';
import { StateSlice } from '../state-slice';
import { ActionReducer, StoreModule, combineReducers } from '@ngrx/store';
import { reducer } from './preference-reducer';
import { initialPreferenceState } from '../preference/preference-state';
import { EffectsModule } from '@ngrx/effects';
import { PreferenceEffects } from './preference-effects';
import { PreferenceDataService } from '@core/data/api/preference/preference-data.service';

@NgModule({
    imports: [
      StoreModule.forFeature(StateSlice.PREFERENCE, (reducer as ActionReducer<any, any>), {
        initialState: initialPreferenceState,
        reducerFactory: combineReducers
      }),
      EffectsModule.forFeature([ PreferenceEffects ])
    ],
    declarations: [],
    providers: [
        PreferenceDataService
    ]
  })
  export class PreferenceStateModule {}